import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class DialogService {
  private zoomInfo = new Subject<any>();

  getZoomInfo(): Observable<any> {
    return this.zoomInfo;
  }

  setZoomInfo(zoomInfo: any) {
    this.zoomInfo.next(zoomInfo);
  }
}
